export class ClearAllStates {
  static readonly type = '[Logout Button] clearAllStates'
  constructor(public loginMessage = '') {}
}
